<template>
  <div class="avantage-desktop-container new-avantage-2025-container">
    <HomeAvantageDesktopBox v-for="(item, index) in avantage" :key="index" :id="removeSpace(item.name)">
      <img :src="item.img" slot="image" alt="" />
      <p slot="name" class="avantage-name text-uppercase">{{ item.name }}</p>
      <h3 slot="title" v-html="item.title"> </h3>
      <p slot="description" class="description" v-html="item.description"></p>
    </HomeAvantageDesktopBox>
  </div>
</template>
<script>
import HomeAvantageDesktopBox from "./HomeAvantageDesktopBox.vue";
export default {
  components: { HomeAvantageDesktopBox },
  props: {
    avantage: Array,
  },
};
</script>
